import { useState } from "react";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { postData, putData } from "helpers/apiHelper";
import { useHistory } from "react-router-dom";
import moment from "moment";
import "react-phone-input-2/lib/bootstrap.css";

export default function CancelSubscription({ showPopup, closePopup, editKey, subscription, refetch }) {
  const history = useHistory();
  const [sending, setSending] = useState(false);
  const [cancelImmediate, setCancelImmediate] = useState(true);

  const handleChange = (event) => {
    setCancelImmediate(event.target.value === "immediate");
  };

  const handleClose = () => {
    setCancelImmediate(true);
    closePopup?.();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setSending(true);

      const url = `/admin/practitioner/subscription/cancel/${editKey}`;
      const payload = {
        subscription_id: subscription?.id?.toString(),
        immediate: cancelImmediate,
      };

      await postData(url, payload);
      typeof refetch === "function" && refetch();
      handleClose();
    } catch (error) {
      console.error(error);
    } finally {
      setSending(false);
    }
  };

  return (
    <Modal
      show={showPopup}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="md"
    >
      <Modal.Header closeButton>
        <Modal.Title className="fw-semibold">
          Cancel Subscription
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Row>
            <Col lg="12" className="my-2">
              <Form.Label className="fw-semibold">Cancellation Type</Form.Label>
              <div className="p-3 border rounded bg-light">
                <Form.Check
                  type="radio"
                  id="cancel-immediate"
                  name="cancelOption"
                  value="immediate"
                  checked={cancelImmediate}
                  onChange={handleChange}
                  label={
                    <>
                      <strong>Immediately</strong>
                      <br />
                      <small className="">
                      {moment().format("MMM D, YYYY")}
                      </small>
                    </>
                  }
                  className="mb-3"
                />
                {(!subscription?.cancel_at) && (
                  <Form.Check
                    type="radio"
                    id="cancel-period-end"
                    name="cancelOption"
                    value="period_end"
                    checked={!cancelImmediate}
                    onChange={handleChange}
                    label={
                      <>
                        <strong>End of Billing Period</strong>
                        <br />
                        <small className="">
                          {subscription?.current_period_end
                              ? moment(subscription.current_period_end).format("MMM D, YYYY")
                              : "N/A"}
                        </small>
                      </>
                    }
                  />
                )}
              </div>
            </Col>
          </Row>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline-secondary" onClick={handleClose}>
          Close
        </Button>
        <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={sending}
            className="d-flex align-items-center"
        >
          {sending ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Cancelling...
            </>
          ) : (
            "Confirm Cancel"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
